import type { UserType } from "@whatslly/types/User";
import type { LoginProviderType } from "@whatslly/types/LoginProviderType";
import type { TFunction } from "i18next";
import type { PermissionInstanceConfig } from "@whatslly/commons/platformPermissions";
import type { OrgConfigs } from "@whatslly/types/OrgConfigs";
export const InjectUserStore = Symbol.for("UserStore");

export interface ILoginData {
  email?: string;
  customDomain?: string;
  app: LoginProviderType;
}

export interface IUserStore {
  initialized?: boolean;
  refreshes?: number;
  accounts?: UserType["accounts"];
  pod?: string;
  isInternalUser?: boolean;
  hasAccountAdmin?: boolean;
  isAnyAdmin?: boolean;
  instanceConfigs?: Pick<OrgConfigs, PermissionInstanceConfig> | null;
  phone?: string;
  user?: UserType;
  loginProvider: LoginProviderType;
  login(data: ILoginData, t?: TFunction): Promise<void | { navigate: string; state?: string[] }>;
  logout(): Promise<void>;
  refreshUser(t: TFunction): Promise<void>;
  updateUserData(newUserData: Partial<UserType>): void;
  canUserLoginToWaba?: boolean;
  canUserLoginToTwilioSms?: boolean;
  etoken?: string;
  isAdmin?: boolean;
  isSuperAdmin?: boolean;
  isSupportUser?: boolean;
  hasUpdateAccessToOrg?: boolean;
  hasAccessToMultipleOrgs?: boolean;
  permissions?(orgId: string | undefined): string;
}
